var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUploadIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "material-symbols:upload"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.2771 15.079V6.59215L6.55967 9.29962L5.09644 7.78968L10.3223 2.58301L15.5481 7.78968L14.0849 9.29962L11.3674 6.59215V15.079H9.2771ZM4.05127 19.2444C3.47643 19.2444 2.9845 19.0406 2.57549 18.6331C2.16649 18.2256 1.96163 17.7351 1.96094 17.1617V14.0377H4.05127V17.1617H16.5933V14.0377H18.6836V17.1617C18.6836 17.7344 18.4791 18.2249 18.0701 18.6331C17.6611 19.0413 17.1688 19.2451 16.5933 19.2444H4.05127Z",
    fill: "#1976D2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/uploadIcon.cb93c22c5a350a5bf4e57fdff62c46d2.svg";
export { ForwardRef as ReactComponent };